import React, { useEffect, useState } from 'react';
import { Layout } from '../components/Layout';
import storage from '@/utils/storage';
import { useNavigate } from 'react-router-dom';
import LawyerEmailVerifyForm from '../components/LawyerEmailVerifyForm';

export const LawyerEmailVerify = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const emailVal = storage.getEmail();
    if (emailVal) {
      setEmail(emailVal);
    } else {
      navigate('/auth/login');
    }
  }, [navigate]);

  return (
    <Layout title="Please verify your email address">
      <LawyerEmailVerifyForm email={email} />
    </Layout>
  );
};
